import { BrandMark } from '../brand/BrandMark';
import './States.css';

export function Loader() {
  return (
    <div className="state">
      <div className="state__spinner" aria-label="Загрузка" role="status" />
    </div>
  );
}

export function Splash() {
  return (
    <div className="state">
      <BrandMark size="lg" stacked />
      <div className="state__spinner" aria-label="Загрузка" role="status" />
    </div>
  );
}

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="state">
      <BrandMark size="lg" stacked />
      <p className="state__title">Что-то пошло не так</p>
      <p className="state__message">{message}</p>
      {onRetry ? (
        <button type="button" className="state__retry" onClick={onRetry}>
          Попробовать снова
        </button>
      ) : null}
    </div>
  );
}
